import journeyCardPreview from "../../../../assets/images/trialMode/journeyCardPreview.png";
import journeyCardPreviewJP from "../../../../assets/images/trialMode/journeyCardPreview_JP.png";
import { TemplatePreview } from "../TemplatePreview";
import { JourneyCardType } from "../types";

export default function Preview({ formData }: { formData: JourneyCardType }) {
  return (
    <div className="relative">
      <img src={formData.market === "JP" ? journeyCardPreviewJP : journeyCardPreview}
           alt="journey card preview" />

      <div className="absolute top-0 left-0">
        <TemplatePreview data={formData} />
      </div>
    </div>
  );
}
